import type { User, UserCredential } from 'firebase/auth'
import { createContext } from 'react'

export interface AuthContextType {
  user: User | null
  loading: boolean
  signInWithGoogle: () => Promise<UserCredential>
  logout: () => Promise<void>
  error: string | null
  clearError: () => void
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
